import { Link } from "react-router-dom";
import { ShieldCheck, Mail, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-navy text-white/80" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-20">
        <div className="grid md:grid-cols-4 gap-12">
          <div className="md:col-span-2">
            <div className="flex items-center gap-3">
              <div className="h-9 w-9 rounded-md bg-white/5 flex items-center justify-center ring-1 ring-white/10">
                <ShieldCheck className="h-4 w-4 text-[#D4AF37]" strokeWidth={2.2} />
              </div>
              <div>
                <div className="font-serif text-xl text-white">Direct Hire Team</div>
                <div className="eyebrow text-[10px] text-white/50">Remote jobs · 11 fields · All 50 states</div>
              </div>
            </div>
            <p className="mt-6 max-w-md text-white/70 leading-relaxed">
              We connect you to the job that's ready for you. Remote roles across payroll, finance, HR, IT, marketing, sales, legal, admin and operations — in all 50 states, with employers in our vetted network.
            </p>
            <div className="mt-6 space-y-2 text-sm text-white/60">
              <div className="flex items-center gap-2">
                <Mail className="h-4 w-4 text-[#10B981]" />
                careers@directhirepayroll.com
              </div>
              <div className="flex items-center gap-2">
                <MapPin className="h-4 w-4 text-[#10B981]" />
                Financial District · New York, NY
              </div>
            </div>
          </div>

          <div>
            <div className="eyebrow text-white/50 mb-4">Explore</div>
            <ul className="space-y-3 text-sm">
              <li><Link to="/" className="hover:text-white">Home</Link></li>
              <li><Link to="/jobs" className="hover:text-white">Browse Jobs</Link></li>
              <li><Link to="/for-employers" className="hover:text-white">For Employers</Link></li>
              <li><Link to="/for-candidates" className="hover:text-white">Submit Your CV</Link></li>
              <li><Link to="/contact" className="hover:text-white">Contact</Link></li>
            </ul>
          </div>

          <div>
            <div className="eyebrow text-white/50 mb-4">Resources</div>
            <ul className="space-y-3 text-sm">
              <li><Link to="/enroll" className="hover:text-white">Free PRC Certificate</Link></li>
              <li><Link to="/career-pathway" className="hover:text-white">Career Pathway</Link></li>
              <li><Link to="/for-candidates#guide" className="hover:text-white">Interview Prep Guide</Link></li>
              <li><Link to="/for-employers#report" className="hover:text-white">2026 Salary Benchmark</Link></li>
              <li><Link to="/admin/login" className="hover:text-white">Admin</Link></li>
            </ul>
          </div>
        </div>

        <div className="hairline my-12 opacity-40" />
        <div className="flex flex-col md:flex-row justify-between items-center text-xs text-white/45">
          <div>© {new Date().getFullYear()} Direct Hire Payroll · Compliance Staffing Solutions. All rights reserved.</div>
          <div className="mt-3 md:mt-0 font-mono tracking-wider">EST. 2018 · NYC</div>
        </div>
      </div>
    </footer>
  );
}
